import { F3SummarySVG } from "./SVGIllustrations";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";

export default function Step6Summary({ metVig, metMod, metWalk, ipaqClass, sittingCat }) {
  return (
    <div>
      <F3SummarySVG complete={true} />

      <p className="text-xs text-center mb-4 font-medium" style={{ color: "#71644C" }}>
        Resumen de tu evaluación IPAQ
      </p>

      <CalculatedBadge
        label="MET vigorosa"
        value={metVig ?? 0}
        unit="MET-min/sem"
        testId="summary-met-vig"
      />
      <CalculatedBadge
        label="MET moderada"
        value={metMod ?? 0}
        unit="MET-min/sem"
        testId="summary-met-mod"
      />
      <CalculatedBadge
        label="MET caminata"
        value={metWalk ?? 0}
        unit="MET-min/sem"
        testId="summary-met-walk"
      />

      {ipaqClass && (
        <CalculatedBadge
          label="MET total / semana"
          value={ipaqClass.metTotal}
          unit="MET-min/sem"
          category={ipaqClass.label}
          categoryColor={ipaqClass.color}
          testId="summary-met-total"
        />
      )}

      {sittingCat && (
        <CalculatedBadge
          label="Sedentarismo"
          value={sittingCat.category}
          categoryColor={sittingCat.color}
          testId="summary-sedentarismo"
        />
      )}

      <div
        className="rounded-xl p-3 mt-3 text-center"
        style={{ background: "#E2F0E8" }}
        data-testid="f3-ready-message"
      >
        <span className="text-[13px] font-semibold" style={{ color: "#157346" }}>
          ¡Listo! Envía tu evaluación IPAQ.
        </span>
      </div>
    </div>
  );
}
